export interface CompanyBase {
  id: string;
  name: string;
  logoUrl?: string;
}

export enum COMPANY_TYPE {
  Public = "Public",
  Private = "Private",
  Unknown = "Unknown"
}

export enum COMPANY_OWNERSHIP_TYPE {
  Private = "Private",
  Public = "Public"
}

// Field names for the add/edit company AntD form. Keeping them in an enum keeps
// the Form.Item `name` props, `getFieldValue`/`setFieldValue` calls and tests in
// sync with a single source of truth.
export enum COMPANY_FORM_FIELD {
  CompanyName = "companyName",
  Type = "type",
  Website = "website",
  LinkedinUrl = "linkedinUrl",
  LinkedinUrn = "linkedinUrn",
  Description = "description",
  IndustryId = "industryId",
  OwnershipType = "ownershipType",
  ExchangeTicker = "exchangeTicker",
  Sector = "sector",
  BusinessModel = "businessModel",
  RegionName = "regionName",
  FoundationYear = "foundationYear",
  RevenueBucket = "revenueBucket",
  EmployeeBucket = "employeeBucket",
  Specialities = "specialities",
  Competitors = "competitors",
  IsDnc = "isDnc",
  DoNotContactKeywords = "doNotContactKeywords",
  Headquarter = "headquarter",
  Address = "address",
  CityId = "cityId",
  CityText = "cityText",
  State = "state",
  CountryId = "countryId",
  ZipCode = "zipCode"
}

export interface CompanyHeadquarterFormValues {
  address: string | null;
  cityText: string | null;
  cityId: string | null;
  state: string | null;
  countryId: string | null;
  zipCode: string | null;
}
